const DateOfBirthType = require("./dateOfBirth");
const GenderType = require("./gender");
const YesNoType = require("./yesno");
const EqualsType = require("./equals");
const BiggerType = require("./bigger");
const SmallerType = require("./smaller");
const TextType = require("./text");
const SelectType = require("./select");
const RadioType = require("./radio");
const RadioButtonType = require("./radioButton");
const BetweenType = require("./between");
const BmiType = require("./bmi");
const ScaleType = require("./scale");
const CheckboxType = require("./checkbox");

function typeFactory(type) {
  switch (type) {
    case "dateofbirth":
      return new DateOfBirthType();
    case "gender":
      return new GenderType();
    case "yesno":
    case "dataconsent":
    case "leadconsent":
    case "lookalikeconsent":
    case "otherconsent":
      return new YesNoType();
    case "equals":
      return new EqualsType();
    case "bigger":
      return new BiggerType();
    case "smaller":
      return new SmallerType();
    case "text":
      return new TextType();
    case "select":
      return new SelectType();
    case "radio": // deprecated - use RadioButtonType instead
      return new RadioType();
    case "radiobutton":
      return new RadioButtonType();
    case "between":
      return new BetweenType();
    case "bmi":
      return new BmiType();
    case "scale":
      return new ScaleType();
    case "checkbox":
      return new CheckboxType();
    default:
      throw `Unknown type '${type}'`;
  }
}

module.exports = typeFactory;
